import { baseAPI } from '~shared/api/base-api';

interface StripeConnectParams {
  studioId?: string;
  locationId?: string;
}

interface StripeConnectResponse {
  url: string;
}

export const getStripeConnectUrl = async (
  params: StripeConnectParams = {},
): Promise<StripeConnectResponse> => {
  const response = await baseAPI.get<StripeConnectResponse>(
    '/payment-processor/stripe-connect/connect',
    { params },
  );
  return response.data;
};
